<template>
  <div>
    <v-dialog v-model="openModal" max-width="650" persistent>
      <v-card>
        <v-card-title class="grey lighten-3">
          <v-icon left color="info">mdi-send</v-icon>
          Enviar a SUNAT (masivo)
        </v-card-title>
        <v-card-text class="pt-4">
          <template v-if="fase === 'confirmar'">
            <p>
              <strong>{{ elegibles.length }}</strong> de <strong>{{ items.length }}</strong>
              ventas seleccionadas son elegibles para emitir boleta/factura.
            </p>
            <v-alert v-if="cantidadNoElegibles > 0" type="warning" dense text>
              Se omitirán {{ cantidadNoElegibles }} venta(s): ya emitidas o con fecha anterior al
              01/03/2024.
            </v-alert>
            <p v-if="elegibles.length === 0">No hay ventas elegibles en la selección.</p>
          </template>

          <template v-if="fase === 'procesando' || fase === 'resultado'">
            <template v-if="fase === 'procesando'">
              <p>Procesando {{ resultados.length }} / {{ elegibles.length }}...</p>
              <v-progress-linear indeterminate color="info" class="mb-4"></v-progress-linear>
            </template>
            <p v-else class="font-weight-bold">
              {{ exitosos }} / {{ elegibles.length }} emitidas correctamente
              <span v-if="fallidos > 0">, {{ fallidos }} fallaron</span>
            </p>

            <v-simple-table dense v-if="resultados.length > 0">
              <thead>
                <tr>
                  <th>Venta</th>
                  <th>Resultado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, idx) in resultados" :key="idx">
                  <td v-text="r.codigo_venta"></td>
                  <td>
                    <v-icon small :color="r.ok ? 'success' : 'error'">
                      {{ r.ok ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                    {{ r.mensaje }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="fase === 'confirmar'">
            <v-btn color="error" outlined @click="cerrar()">
              <v-icon left>mdi-backspace</v-icon> Cancelar
            </v-btn>
            <v-btn color="success" :disabled="elegibles.length === 0" @click="iniciar()">
              <v-icon left>mdi-check-bold</v-icon> Confirmar
            </v-btn>
          </template>
          <template v-else-if="fase === 'procesando'">
            <v-btn color="error" outlined @click="detenido = true">
              <v-icon left>mdi-stop</v-icon> Detener
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="primary" @click="cerrar()">
              <v-icon left>mdi-check</v-icon> Cerrar
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openModal: false,
      items: [],
      fase: 'confirmar',
      resultados: [],
      detenido: false,
    };
  },
  props: {
    objModalEmitirSunatMasivo: {
      type: Object,
    },
  },
  computed: {
    elegibles() {
      return this.items.filter(
        (item) =>
          this.$moment(item.fecha_registro).isSameOrAfter('2024-03-01') &&
          !item.nubefact_comprobante_emitido_result
      );
    },
    cantidadNoElegibles() {
      return this.items.length - this.elegibles.length;
    },
    exitosos() {
      return this.resultados.filter((r) => r.ok).length;
    },
    fallidos() {
      return this.resultados.filter((r) => !r.ok).length;
    },
  },
  watch: {
    objModalEmitirSunatMasivo(val) {
      this.openModal = val.openModal;
      this.items = val.items || [];
      this.fase = 'confirmar';
      this.resultados = [];
      this.detenido = false;
    },
  },
  methods: {
    async iniciar() {
      this.fase = 'procesando';
      this.detenido = false;

      for (const item of this.elegibles) {
        if (this.detenido) break;

        try {
          const response = await this.axios({
            method: 'POST',
            url: 'api/panel/ventas/v2/emitirComprobanteSunat',
            data: { idventa: item.idventa },
          });

          this.resultados.push({
            codigo_venta: item.codigo_venta,
            ok: true,
            mensaje: response.data.mensaje,
          });
        } catch (error) {
          const data = error.response ? error.response.data : null;
          this.resultados.push({
            codigo_venta: item.codigo_venta,
            ok: false,
            mensaje:
              (data && (data.mensaje || data.error)) ||
              'Ocurrió un error al emitir el comprobante.',
          });
        }
      }

      this.fase = 'resultado';
      this.$parent.listarRegistros();
    },

    cerrar() {
      this.openModal = false;
      this.fase = 'confirmar';
      this.resultados = [];
      this.detenido = false;
    },
  },
};
</script>
